module.exports = __webpack_public_path__ + "img/40.d2dfef2.svg";